// ToDo: temporary enum ?
export enum KnmErknmTypeIdsByCodeEnum {
  PP248P294 = 6,
  PP = 4,
  VP = 5,
}
